<template>
    <div class="subscribe text_11" :class="[subscribeFormClass]">
        <div v-if="!hideLabel" class="subscribe__label">{{ $t("subscribe_mail") }}</div>
        <form class="subscribe__form" @submit="subscribe($event)">
            <div class="form-group">
                <label :aria-label="emailPlaceholder || $t('el_mail')">
                    <input
                        type="text"
                        :placeholder="emailPlaceholder || $t('el_mail')"
                        name="email"
                        class="form-group__input form-group__input--border text_11"
                        :class="{ 'form-group__input--lonley': showSubmit }"
                        v-model="userEmail" />
                </label>
                <div class="form-group__validation text_11" v-if="notValidEmail">
                    {{ $t("subscribe_wrong_mail") }}
                </div>
                <transition v-if="!showSubmit" name="fade" mode="out-in">
                    <button :aria-label="$t('send')" type="submit" class="button button--secondary button--small">
                        {{ $t("subscribe_short") }}
                    </button>
                </transition>
            </div>
            <div class="form-group" :class="{ 'form-group--float': $device.isDesktop && showSuccessMessage }">
                <AgreenemtCheckboxses
                    label-class="text_11"
                    v-if="!userSubscribed"
                    :userSubscribe="userSubscribe"
                    :userSubscribeAd="userSubscribeAd"
                    @update:userSubscribe="userSubscribe = $event"
                    @update:userSubscribeAd="userSubscribeAd = $event"></AgreenemtCheckboxses>
                <div class="form-group__label" v-else>
                    {{ successMessage || $t("subscribe_success") }}
                </div>
            </div>
            <button
                v-if="showSubmit && !userSubscribed"
                class="subscribe__submit button button--dark text_11"
                :class="[buttonClass]"
                type="submit">
                {{ buttonText || $t("subscribe_submit") }}
            </button>
            <transition name="fade">
                <div v-if="showErrors" class="text_11" style="color: red">{{ $t("required_all_fields") }}</div>
            </transition>
        </form>
    </div>
</template>
<script>
import AgreenemtCheckboxses from "~/components/form/AgreenemtCheckboxses";

export default {
    name: "Subscribe",
    components: { AgreenemtCheckboxses },
    props: {
        subscribeFormClass: {
            type: String,
            default: "",
        },
        buttonClass: {
            type: String,
            default: "",
        },
        buttonText: {
            type: String,
            default: "",
        },
        emailPlaceholder: {
            type: String,
            default: "",
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        showSubmit: {
            type: Boolean,
            default: false,
        },
        showSuccessMessage: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: "",
        },
        successMessage: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            userEmail: "",
            userSubscribe: false,
            userSubscribeAd: false,
            userSubscribed: false,
            notValidEmail: false,
            showErrors: false,
        };
    },
    computed: {
        isShowAgree() {
            return this.$grom.validateEmail(this.userEmail);
        },
        allowSubmit() {
            if (this.isShowAgree && this.userSubscribe && this.userSubscribeAd) {
                return true;
            }
            return false;
        },
    },
    methods: {
        async subscribe(event) {
            event.preventDefault();
            this.showErrors = false;

            if (!this.isShowAgree) {
                this.notValidEmail = false;
            }

            if (!this.allowSubmit) {
                this.showErrors = true;
                return;
            }

            let email = this.userEmail.replace(/^\s+|\s+$/g, "");

            await this.$axios.post("/api/subscribe", {
                email: email,
                tags: this.target ? [this.target] : [],
                create_promocode: true,
            });
            this.isSended = true;

            if (this.target === "basement") {
                this.$grom.reachGoal("footer-subscrbe");
            } else {
                this.$grom.reachGoal("subscrbe", { target: this.target });
            }

            (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
                rrApi.setEmail(email);
            });

            this.userSubscribed = true;
            this.userSubscribe = false;
            this.userSubscribeAd = false;
        },
    },
};
</script>

<style lang="less">
.subscribe {
    position: relative;
    width: 100%;
    @media @sm {
        padding: 16px 0;
        &.black-friday-subscribe {
            padding: 0;
        }
    }
    label {
        flex-grow: 1;
    }
    .subscribe__submit {
        width: 100%;
        margin-top: 30px;
    }
    &__label {
        position: absolute;
        bottom: 100%;
        margin-bottom: 16px;
        @media @sm {
            position: static;
            margin-bottom: 16px;
        }
    }
    .button--square {
        width: 32px;
        height: 32px;
        border: 1px @border2 solid;
        border-left: 0;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // background: none;
        // flex-shrink: 0;
        // cursor: pointer;
        color: @text_3;
        // .trs(all);
        // &:hover {
        //     color: #fff !important;
        //     background: @accent;
        //     border-color: @accent;
        // }
        // &[disabled] {
        //     pointer-events: none;
        // }
    }
    .form-group__input {
        padding-left: 16px;
        height: 32px;
    }
    .form-group__input--lonley {
        border: 1px solid #000;
        &::placeholder {
            color: #000;
        }
    }
    .form-group__validation {
        position: absolute;
        top: 100%;
        color: #dda491;
    }
    .form-group--float {
        cursor: pointer;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 20px;
        .form-group__label {
            margin-top: 0;
        }
    }
    .form-group__label--checkbox {
        cursor: pointer;
    }
}
.black-friday-subscribe {
    .form-group__label {
        margin-top: 20px;
    }
    .form-group__input {
        height: 35px;
    }
    .subscribe__submit {
        margin-top: 20px;
    }
    .form-group__checkbox {
        width: 18px;
        height: 18px;
        border-color: #adadad;
    }
    .form-group__label--checkbox {
        align-items: flex-start;
        span {
            color: #adadad;
        }
    }
}
</style>
